import * as React from "react";
import * as $ from "jquery";
import "jquery-ui/ui/widgets/autocomplete";
import { IBaseFormElementProps, BaseFormElement } from "../../../../../../../react-core/Html/BaseFormElement";
import * as classNames from "classNames";
import { IBaseTextBoxEditorProps, BaseTextBoxEditor } from "../../../../../../../react-core/Html/BaseTextBoxEditor";
import { CedingSchemeClient } from "../../../../../../../Wrap/Api/Transfer/CedingScheme";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { CedingSchemeModel } from "../../../../../../../Wrap/Models/Models/Transfer/CedingSchemeModel";

export class AutocompleteResult {
    value: string;
    label: string;
    data: any;
}

interface ICedingSchemeSearchInputSpecificProps extends IBaseFormElementProps {
    value: string;
    // label: string;
    id?: string;
    cssWrapper?: string;
    placeholder?: string;
    type: SubAccountType;

    onSelected: (item: any) => void;
    onChange?: (item: any) => void;
    onLookupError: () => void;

    automationId?: string;

    disabled?: boolean;

    subLabelId?: string;
    required?: string;
}

interface ICedingSchemeSearchInputProps
    extends ICedingSchemeSearchInputSpecificProps,
        React.Props<CedingSchemeSearchInput> {}

export class CedingSchemeSearchInput extends BaseFormElement<ICedingSchemeSearchInputProps, any> {
    private _InputRef: HTMLInputElement;

    private _retrieveCedingSchemeClient: CedingSchemeClient;

    constructor(props: ICedingSchemeSearchInputProps) {
        super(props);
        this.state = {};
        this._retrieveCedingSchemeClient = new CedingSchemeClient();
    }

    public setDisable() {
        this.setState({ disable: true });
    }

    public isValid(): boolean {
        return true;
    }

    public componentDidMount() {
        const $inputRef = $(this._InputRef);

        const autocomplete = ($inputRef as any)
            .autocomplete({
                source: (request, responseFn) => {
                    this._retrieveCedingSchemeClient
                        .get(this.props.type, this.getPcaSearchValue())
                        .onSuccess((results: Array<CedingSchemeModel>) => {
                            const mappedSearchResults = this.transformSearchResults(results);
                            responseFn(mappedSearchResults);
                        });
                },
                minLength: 3,
            })
            .on("autocompleteselect", (event: any, ui: any) => {
                this.handleSearchResultSelection(ui.item);
            });
    }

    private transformSearchResults(items: CedingSchemeModel[]): Array<AutocompleteResult> {
        const results = new Array<AutocompleteResult>();

        if (!items.length) {
            const emptyResult: AutocompleteResult = {
                label: "No results found",
                value: null,
                data: null,
            };
            results.push(emptyResult);
            return results;
        } else {
            for (let i = 0; i < items.length; i++) {
                const item = new AutocompleteResult();
                item.data = items[i];
                if (items[i].Name) {
                    item.label = items[i].Name;
                }

                results.push(item);
            }

            return results;
        }
    }
    public render(): JSX.Element {
        const cssClassNames = classNames("form-group search-form", this.props.cssWrapper);
        return (
            <div className={cssClassNames}>
                <label className="control-label" htmlFor={this.props.id}>
                    Ceding scheme
                </label>
                <div className="controls-wrap">
                    <div className="controls-text">
                        <span className="search-icon"></span>
                        <input
                            type="text"
                            id={this.props.id}
                            className="search-input"
                            // defaultValue={this.props.value}
                            placeholder={this.props.placeholder}
                            disabled={this.state.disable == true ? true : this.props.disabled}
                            ref={(inputRef: HTMLInputElement) => (this._InputRef = inputRef)}
                            data-automation-id={this.props.automationId}
                            required={this.props.required ? true : false}
                        />
                    </div>
                </div>
            </div>
        );
    }

    private handleSearchResultSelection(selectedResult: AutocompleteResult) {
        this.props.onSelected(selectedResult.data);
        setTimeout(() => {
            this._InputRef.value = "";
        }, 200);
    }

    private getPcaSearchValue(): string {
        return this._InputRef.value;
    }
}

interface ICedingSchemeSearchInputEditorProps
    extends IBaseTextBoxEditorProps,
        ICedingSchemeSearchInputSpecificProps,
        React.Props<CedingSchemeSearchInputEditor> {}

export class CedingSchemeSearchInputEditor extends BaseTextBoxEditor<ICedingSchemeSearchInputEditorProps> {
    constructor(props: ICedingSchemeSearchInputEditorProps) {
        super(props);
    }

    protected getInput() {
        return <CedingSchemeSearchInput {...(this.props as any)} id={this.state.inputGroupId} />;
    }
}
